import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

export const clockOnLevel2Link = targetPage => {
    const category = GA_EVENTS.navigation.category;
    const action = GA_EVENTS.navigation.actions.clickOnLevel2Link;

    setBehaviourEvent({
        category,
        action,
        label: targetPage,
        beforeUnload: true,
    });
};
